import { ParticipantTypes, Role } from "@generated/graphql";

export const isResaleReporter = (userRoles: Role[]): boolean => userRoles.includes(Role.RESALE_REPORTER);

export const isRoyaltyRecipient = (userRoles: Role[]): boolean => userRoles.includes(Role.ROYALTY_RECIPIENT);

type RegistrationType = {
  isResaleReporterOnly: boolean;
  isRoyaltyRecipientOnly: boolean;
  isAmp: boolean;
  isArtCentreReporter: boolean;
  isArtCentreRecipient: boolean;
  isArtist: boolean;
  isBeneficiary: boolean;
  isCollaboration: boolean;
  isCMO: boolean;
  isArtCenter?: boolean;
};

export const getRegistrationType = (userRoles: Role[], participantType: ParticipantTypes[] = []): RegistrationType => {
  const isResaleReporterOnly = isResaleReporter(userRoles) && !isRoyaltyRecipient(userRoles);
  const isRoyaltyRecipientOnly = !isResaleReporter(userRoles) && isRoyaltyRecipient(userRoles);

  const isAmp = isResaleReporterOnly && participantType.includes(ParticipantTypes.AMP);
  const isArtCentreReporter = isResaleReporterOnly && participantType.includes(ParticipantTypes.ART_CENTRE);
  const isArtCentreRecipient = isRoyaltyRecipientOnly && participantType.includes(ParticipantTypes.ART_CENTRE);
  const isArtist = isRoyaltyRecipientOnly && participantType.includes(ParticipantTypes.ARTIST);
  const isBeneficiary = isRoyaltyRecipientOnly && participantType.includes(ParticipantTypes.BENEFICIARY);
  const isCollaboration = isRoyaltyRecipientOnly && participantType.includes(ParticipantTypes.COLLABORATION);
  const isCMO = participantType.includes(ParticipantTypes.CMO);
  const isArtCenter = participantType.includes(ParticipantTypes.ART_CENTRE);
  return {
    isResaleReporterOnly,
    isRoyaltyRecipientOnly,
    isAmp,
    isArtCentreReporter,
    isArtCentreRecipient,
    isArtist,
    isBeneficiary,
    isCollaboration,
    isCMO,
    isArtCenter,
  };
};
